import React from "react";
import { useState, useEffect, useRef } from "react";
import Navbar from "../../../../components/Navbar";
import SideBar from "../../../../components/SideBar";
import JobDescription from "../../RecrtProcess/candidate/component/job-description-dropdown";
import CommanDropdown from "../../../../components/dropdown";
import ReactDatePicker from "react-datepicker";
import { Form, Col } from "react-bootstrap";
import moment from "moment";
import { API_URL } from "../../../../constants";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import validate from "./validate";
import {
  isCtcInputAllowed,
  validateCtc,
  toCtcAmount,
} from "../../../../utils/ctc";
import { toast } from "react-toastify";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useNavigate } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { PhoneInput } from 'react-international-phone';
const HrAuthority = () => {
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);
  let [errors, setErrors] = useState({});
  const [jobTitleOpts, setJObTitleOpts] = useState([]);
  const { candidate_id, job_description_id } = useParams();
  const [gender_options, setGenderOption] = useState([]);
  const [candidateStatus, setCandidateStatus] = useState([]);
  const [activeKey, setActiveKey] = useState("0");
  const [taDocumentVerify, setTaDocumentVerify] = useState(0);
  const initialFormData = {
    JobDescriptionID: "",
    appliedDate: "",
    FirstName: "",
    LastName: "",
    gender: "",
    Email: "",
    DateOfBirth: "",
    MobileNo: "",
    MobileNo2: "",
    candidate_status: "",
    ScreeningRejectRemark: "",
    expectedDoj: "",
    actualDoj: "",
    location: "",
    CurrentCTC: "",
    ExpectedCTC: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("HR Action"))
  }, [])

  const handleSubmit = async (e) => {
  
    e.preventDefault();
    if ((formData.candidate_status?.value == 1313 || (formData.candidate_status?.label && formData.candidate_status.label.toLowerCase().includes("hr to be scheduled"))) && taDocumentVerify !== 1) {
      toast.error("Document verification is pending");
      return;
    }
      let mandatory_field = [
        "job_title",
        "appliedDate",
        "FirstName",
        "LastName",
        "gender",
        "Email",
        "DateOfBirth",
        "MobileNo",
        "candidate_status",
        "location",
        "ScreeningRejectRemark",
        "CurrentCTC",
        "ExpectedCTC",
      ];
    let isFormInvalid = false;
    for (let field of mandatory_field) {

      let error = await validate([field], formData[field], formData);
      if (error.status == true) {
        isFormInvalid = true;
        // CTC can fail on format as well, so show what actually went wrong
        if (field === "CurrentCTC" || field === "ExpectedCTC") {
          toast.error(error.message);
        }
      }
      setErrors((errors) => ({
        ...errors,
        [field]: error,
      }));
    }
    if (!isFormInvalid) {
      setSubmit(true);
      let response = await PostServiceCaller(
        `${API_URL}hr-authority-update/${candidate_id}`,
        formData,
        "post"
      );
      if (response?.data?.status == "success") {
        toast.success(response?.data?.message);
        setSubmit(false);
        navigate("/candidate-in-process");
      } else {
        setSubmit(false);
        toast.error(response?.data?.message);
      }
    }
  };

  const handleOnTouch = async (e) => {
    const { name, value } = e.target;
    let error = await validate(name, value, formData);
    setErrors((errors) => ({
      ...errors,
      [name]: error,
    }));
  };
  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "CurrentCTC" || name === "ExpectedCTC") {
      // Only whole figures or decimals in rupees, so 820000 stays 820000
      if (!isCtcInputAllowed(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: {
            status: true,
            message:
              "Enter the amount in rupees, numbers only (e.g. 820000 or 820000.50).",
          },
        }));
        return;
      }
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
      // The amount itself is checked on blur, so a half typed figure is not flagged
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: { status: false, message: "" },
      }));
      return;
    }

    if (name === "MobileNo" && value.length > 10) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        MobileNo: { message: "Mobile number must be exactly 10 digits" },
      }));
      return;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        MobileNo: prevErrors.MobileNo ? undefined : prevErrors.MobileNo,
      }));
    }

    // Validate first name and last name
    const alphabetRegex = /^[A-Za-z]*$/;
    if (
      (name === "FirstName" || name === "LastName") &&
      !alphabetRegex.test(value)
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: { message: "Only alphabetic characters are allowed." },
      }));
      return; // Exit if the input is invalid
    } else {
      // Clear the error if input is valid
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: prevErrors[name] ? undefined : prevErrors[name],
      }));
    }

    // Update FormData state with the new value
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };


  const handleCtcBlur = (event) => {
    const { name, value } = event.target;
    const label = name === "CurrentCTC" ? "Current CTC" : "Expected CTC";
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateCtc(value, label),
    }));
  };

  const handleDateChange = (date, field) => {
    setFormData({ ...formData, [field]: moment(date).format("DD-MMM-YYYY") });
  };
  const handleDropdownChange = (e, name) => {
    const selected = typeof e?.target == "undefined" ? e : e?.target;
    if (name === "candidate_status" && (selected?.value == 1313 || (selected?.label && selected.label.toLowerCase().includes("hr to be scheduled"))) && taDocumentVerify !== 1) {
      toast.error("Document verification is pending");
      return;
    }
    const { value } = typeof e?.target == "undefined" ? e : e?.target;
    setFormData({
      ...formData,
      [name]: typeof e?.target == "undefined" ? e : value,
    });
    if(value!=''){
      setErrors((errors) => ({
        ...errors,
        [name]: {status:false,message:''},
      }));
    }
  };
  async function fetchData() {
    try {
      let interviewDetailsUrl = `${API_URL}candidateprocess/${candidate_id}`;
      let response = await GetServiceCaller(interviewDetailsUrl);
   
      let candidateDetails = response?.data?.data?.candidate_details[0];
      setTaDocumentVerify(candidateDetails?.TADocumentVerify || 0);
      // job title selected
      const response2 = response?.data?.data?.job_titles;
      const jobtitleOption = response2?.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      let selectedJobTitle = jobtitleOption.find(
        (o) => o.value == candidateDetails.JobMasterID
      );
      setJObTitleOpts(jobtitleOption);
      // Gender option and selected gender
      const genderOpt = response?.data?.data?.gender?.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setGenderOption(genderOpt);
      let selected_gender = genderOpt.find(
        (o) => o.value == candidateDetails.Gender_020
      );
      //Candidate status
      const candidateStatusOpt = response?.data?.data?.candidate_status?.map(
        (option) => ({
          value: option.value,
          label: option.text,
        })
      );
      setCandidateStatus(candidateStatusOpt);
      let selected_candidate_status = candidateStatusOpt.find(
        (o) => o.value == candidateDetails.CandidateStatus_181
      );
      let updatedFormData = {
        JobDescriptionID: selectedJobTitle,
        appliedDate: moment(candidateDetails.AppliedDate).format("DD-MMM-YYYY"),
        FirstName: candidateDetails.FirstName,
        LastName: candidateDetails.LastName,
        gender: selected_gender,
        Email: candidateDetails.EmailID,
        DateOfBirth: moment(candidateDetails.DateOfBirth).format("DD-MMM-YYYY"),
        MobileNo: candidateDetails.MobileNo,
        MobileNo2: candidateDetails.MobileNo1,
        candidate_status: selected_candidate_status,
        ScreeningRejectRemark: candidateDetails.ScreeningRejectRemark || "",
        expectedDoj: candidateDetails.ExpectedJoiningDate
          ? moment(candidateDetails.ExpectedJoiningDate).format("DD-MM-YYYY")
          : "",
        actualDoj: candidateDetails.ActualJoiningDate
          ? moment(candidateDetails.ActualJoiningDate).format("DD-MM-YYYY")
          : "",
        location: candidateDetails.JoiningLocation
          ? candidateDetails.JoiningLocation
          : "",
        CurrentCTC: toCtcAmount(candidateDetails.CurrentCTC),
        ExpectedCTC: toCtcAmount(candidateDetails.ExpectedCTC),
      };
      setFormData(updatedFormData);
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
           <div className="Container">
            <form id="formOne" className="rounded mt-2 bg-white" onSubmit={handleSubmit}>
              <div className="container-fluid">
                      <div className="row">
                        <div className="col-md-3">
                          <label className="form-label">
                            Job Title<span class="required">*</span>
                          </label>
                          <Select
                            value={formData.JobDescriptionID}
                            onBlur={handleOnTouch}
                            name="JobDescriptionID"
                            onChange={(selected) =>
                              handleDropdownChange(selected, "JobDescriptionID")
                            }
                            class="form-control"
                            options={jobTitleOpts}
                            required
                          />

                          {errors?.JobDescriptionID?.status && (
                            <span class="error">
                              {errors?.JobDescriptionID?.message}
                            </span>
                          )}

                          {/* <span class="error">
                              {errors?.job_title?.message}
                            </span> */}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">
                            Applied Date <span className="required">*</span>
                          </label>
                            <ReactDatePicker
                              autoComplete="off"
                              showPopperArrow
                              showIcon
                              icon="fa fa-calendar"
                              className="form-control"
                              placeholderText="Applied Date"
                              format="DD-MMM-YYYY"
                              name="appliedDate"
                              id="appliedDate"
                              onChange={(date) =>
                                handleDateChange(date, "appliedDate")
                              }
                              value={formData.appliedDate}
                            />

                            {errors?.appliedDate?.status && (
                              <span class="error">
                                {errors?.appliedDate?.message}
                              </span>
                            )}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">
                            First Name <span className="required">*</span>
                          </label>
                            <Form.Control
                              type="text"
                              name="FirstName"
                              onChange={handleChange}
                              value={formData.FirstName}
                              onBlur={handleOnTouch}
                              placeholder="First Name"
                            />
                           {errors?.FirstName?.status && (
                             <span class="error">
                             {errors?.FirstName?.message}
                           </span>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">
                            Last Name <span className="required">*</span>
                          </label>
                            <Form.Control
                              type="text"
                              name="LastName"
                              onChange={handleChange}
                              value={formData.LastName}
                              onBlur={handleOnTouch}
                              placeholder="Last Name"
                            />
                          {errors?.LastName?.status && (
                            <span class="error">
                            {errors?.LastName?.message}
                          </span>
                          )}
                        </div>
                      </div>
                  
                  {/* item 2 */}
               
                      <div className="row mt-3">
                       <div className="col-md-3">
                          <label className="form-label">
                            Gender <span className="required">*</span>
                          </label>
                            <Select
                              name="gender"
                              value={formData.gender}
                              options={gender_options}
                              onChange={(e) =>
                                handleDropdownChange(e, "gender")
                              }
                            />
                           {errors?.gender?.status && (
                             <span class="error">{errors?.gender?.message}</span>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">
                            Email ID <span className="required">*</span>
                          </label>
                            <Form.Control
                              type="text"
                              name="Email"
                              onChange={handleChange}
                              value={formData.Email}
                              onBlur={handleOnTouch}
                              placeholder="Email Id"
                            />
                            {errors?.Email?.status && (
                           <span class="error">{errors?.Email?.message}</span>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">
                            {" "}
                            Contact No<span className="required">*</span>{" "}
                          </label>
                            {/* <Form.Control
                              type="number"
                              name="MobileNo"
                              onChange={handleChange}
                              value={formData.MobileNo}
                              onBlur={handleOnTouch}
                              placeholder="Mobile No"
                            /> */}
                                           <input
                      // defaultCountry="in"
                      // className="input.react-international-phone-input"
                      name="MobileNo"
                      className="form-control"
                      value={(formData.MobileNo ? formData.MobileNo : "")}
                      // onChange={(phone) => {
                      //   const isValid = phone && phone.length > 4;
                      //   setFormData({
                      //     ...formData,
                      //     MobileNo: isValid ? phone : ""
                      //   });
                      //   setErrors((errors) => ({
                      //     ...errors,
                      //     MobileNo: isValid ? "" : "Invalid phone number"
                      //   }));
                      // }}
                                                    onChange={handleChange}

                      placeholder="Contact No."
                    />
                          
                            {errors?.MobileNo?.status && (
                                       <span class="error">
                                       {errors?.MobileNo?.message}
                                     </span>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">Alternate Contact No</label>
                            {/* <Form.Control
                              maxLength={10}
                              minLength={10}
                              type="text"
                              name="MobileNo2"
                              onChange={handleChange}
                              value={formData.MobileNo2}
                              onBlur={handleOnTouch}
                              placeholder="Mobile No 2"
                            /> */}
                                        <input
                      // defaultCountry="in"
                      // className="input.react-international-phone-input"
className="form-control"
                      name="MobileNo2"
                      value={(formData.MobileNo2 ? formData.MobileNo2 : "")}
                      // onChange={(phone) => {
                      //   const isValid = phone && phone.length > 4;
                      //   setFormData({
                      //     ...formData,
                      //     MobileNo2: isValid ? phone : ""
                      //   });
                      // }}
                                                    onChange={handleChange}

                      placeholder="Contact No."
                    />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-3">
                          <label className="form-label">
                            DOB <span className="required">*</span>{" "}
                          </label>
                            <CustomDatePicker
                              handleChange={handleChange}
                              value={formData.DateOfBirth}
                              name="DateOfBirth"
                              id="DateOfBirth"
                              className="form-control"
                              placeholderText="Date Of Birth"
                              maxDate={new Date()}
                            ></CustomDatePicker>
                         {errors?.DateOfBirth?.status && (
                                 <span class="error">
                                 {errors?.DateOfBirth?.message}
                               </span>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">Exp. DOJ</label>
                            <ReactDatePicker
                              autoComplete="off"
                              minDate={new Date()}
                              showPopperArrow
                              showIcon
                              icon="fa fa-calendar"
                              className="form-control"
                              placeholderText="Expected DOJ"
                              format="DD-MMM-YYYY"
                              name="expectedDoj"
                              id="expectedDoj"
                              onChange={(date) =>
                                handleDateChange(date, "expectedDoj")
                              }
                              value={formData.expectedDoj}
                            />
                   
                        </div>
                        <div className="col-md-3">
                          <Form.Label>Act. DOJ</Form.Label>
                          <div className=" ">
                            <ReactDatePicker
                              autoComplete="off"
                              minDate={new Date()}
                              showPopperArrow
                              showIcon
                              icon="fa fa-calendar"
                              className="form-control"
                              placeholderText="Actual DOJ"
                              format="DD-MMM-YYYY"
                              name="actualDoj"
                              id="actualDoj"
                              onChange={(date) =>
                                handleDateChange(date, "actualDoj")
                              }
                              value={formData.actualDoj}
                            />
                          </div>
                        </div>
                          <div className="col-md-3">
                            <label className="form-label">
                              Joining Location
                              {formData.candidate_status?.label !== "Screening Reject" && (
                                <span className="required">*</span>
                              )}
                            </label>
                            <Form.Control
                              type="text"
                              name="location"
                              placeholder="Joning Location"
                              onChange={handleChange}
                              value={formData.location}
                              onBlur={handleOnTouch}
                            />
                        
                            {errors?.location?.status && (
                                     <span class="error">
                                     {errors?.location?.message}
                                   </span>
                          )}
                          </div>
                      </div>
                   
                      <div className="row mt-3">
                        <div className="col-md-3">
                          <label className="form-label">
                            Current CTC (in Rupees){" "}
                            <span className="required">*</span>
                          </label>
                          <Form.Control
                            type="text"
                            inputMode="decimal"
                            className="text-end"
                            name="CurrentCTC"
                            placeholder="e.g. 820000"
                            onChange={handleChange}
                            onBlur={handleCtcBlur}
                            value={formData.CurrentCTC}
                          />
                          {errors?.CurrentCTC?.status && (
                            <span class="error">
                              {errors?.CurrentCTC?.message}
                            </span>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">
                            Expected CTC (in Rupees){" "}
                            <span className="required">*</span>
                          </label>
                          <Form.Control
                            type="text"
                            inputMode="decimal"
                            className="text-end"
                            name="ExpectedCTC"
                            placeholder="e.g. 900000"
                            onChange={handleChange}
                            onBlur={handleCtcBlur}
                            value={formData.ExpectedCTC}
                          />
                          {errors?.ExpectedCTC?.status && (
                            <span class="error">
                              {errors?.ExpectedCTC?.message}
                            </span>
                          )}
                        </div>

                  {/* item 3 */}

                        <div className="col-md-3">
                          <label className="form-label">
                            Candidate Status <span className="required">*</span>
                          </label>
                            <Select
                              name="candidate_status"
                              value={formData.candidate_status}
                              options={[
                                { value: "", label: "Select..." },
                                ...candidateStatus,
                              ]}
                              onChange={(e) =>
                                handleDropdownChange(e, "candidate_status")
                              }
                              onBlur={handleOnTouch}
                            />
                  
                            {errors?.candidate_status?.status && (
                                    <span class="error">
                                    {errors?.candidate_status?.message}
                                  </span>
                          )}
                        
                        </div>
                        {formData.candidate_status?.label === "Screening Reject" && (
                          <div className="col-md-3">
                            <label className="form-label">
                              Screening Reject Remark <span className="required">*</span>
                            </label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              name="ScreeningRejectRemark"
                              placeholder="Enter reject remark"
                              onChange={handleChange}
                              value={formData.ScreeningRejectRemark}
                              onBlur={handleOnTouch}
                            />
                            {errors?.ScreeningRejectRemark?.status && (
                              <span className="error">
                                {errors?.ScreeningRejectRemark?.message}
                              </span>
                            )}
                          </div>
                        )}
                        </div>
      
                <div className="row mt-3">
                  <div className="text-end">
                                       <button 
      className="cancel-btn me-2" 
      onClick={() => navigate('/candidate-in-process')}
    >
      Cancel
    </button>
                    <button
                      type="submit"
                      disabled={submitted ? true : false}
                      onClick={handleSubmit}
                      className="custom-btn"
                    >
                      {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

      </>
    );
  }
};
export default HrAuthority;
